import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const EmployerTANHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<h5 className="text-start">
					Ensure that you add the Employer Name and Employer TAN from your Form 16
				</h5>

				<img
					src={`${appConstants.basePath}/assets/images/hints/employer-tan.png`}
					alt="TAN"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default EmployerTANHint;
